module.exports = __webpack_public_path__ + "static/media/back.8aa1d777.svg";